import { render, staticRenderFns } from "./MigrateWebsite.vue?vue&type=template&id=b71857ee&"
import script from "./MigrateWebsite.vue?vue&type=script&lang=js&"
export * from "./MigrateWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b71857ee')) {
      api.createRecord('b71857ee', component.options)
    } else {
      api.reload('b71857ee', component.options)
    }
    module.hot.accept("./MigrateWebsite.vue?vue&type=template&id=b71857ee&", function () {
      api.rerender('b71857ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepOne/MigrateWebsite.vue"
export default component.exports